import { createFileRoute, redirect } from '@tanstack/react-router';

// Студия переехала в раздел учебной программы
export const Route = createFileRoute('/studio/')({
  beforeLoad: () => {
    throw redirect({ to: '/curriculum/books', replace: true });
  },
});
